import { DEFAULT_LOCATION, ITenantConfig } from '@northladder/services';

import { ITenantDetailsResponseDataRaw } from '../../tenants-api';
/**
 * This formats the tenant config response to suit the app's needs.
 * NOTE: This should best be renamed to `formatTenantConfig`.
 * TODO: Revise this with `formatB2BTenantConfigResponse`
 */
export function formatTenantEnvDetails(
  responseData: ITenantDetailsResponseDataRaw,
  identifier: string,
  logoUrl: string
): ITenantConfig {
  const {
    tenantId,
    defaultCurrency: currency,
    configuration,
    label,
  } = responseData;

  const { phoneNumberPrefixes, basePath } = configuration?.common || {};
  const countryCode = phoneNumberPrefixes?.[0] || '';
  const apiBaseURL = basePath?.genericService;
  const cdnBaseUrl = `${basePath?.genericCdn}/`;

  const {
    buyerAppUrl,
    contactInformation,
    termsAndConditions,
    workingHours,
    emailOTPForOnboarding,
  } = configuration?.apps?.dealer || {};

  const buyerConfig = configuration?.apps?.buyer || {};
  const commonAppConfig = configuration?.apps?.common || {};

  const {
    contactNumber = '',
    whatsappNumber = '',
    address = '',
    email = '',
    coordinates = DEFAULT_LOCATION,
  } = contactInformation || {};

  return {
    address,
    apiBaseURL,
    buyerConfig,
    buyerAppUrl,
    cdnBaseUrl,
    commonAppConfig,
    contactNumber,
    coordinates,
    countryCode,
    currency,
    email,
    emailOTPForOnboarding,
    identifier,
    label,
    logoUrl,
    tenantId,
    termsAndConditions,
    whatsappNumber,
    workingHours,
  };
}
